import React from 'react';

const TermsPage = () => {
    return (
        <div className="container">
            <h1 className="header">Terms of Service</h1>
            <p><strong>Last updated:</strong> March 20, 2026</p>
            <p><strong>Version:</strong> 1.0</p>

            <h2>Acceptance</h2>
            <p>
                By using Uranium Baseball, you agree to these terms. If you do not agree, do not use the service.
            </p>

            <h2>Age Requirement</h2>
            <p>
                You must be at least 13 years old to use Uranium Baseball. By creating an account,
                you confirm that you meet this age requirement.
            </p>

            <h2>Accounts</h2>
            <p>
                You must provide a valid email address to create an account, or sign in through
                Google or Apple. You are responsible for maintaining the security of your account
                credentials. One account per person. We reserve the right to remove duplicate accounts.
            </p>

            <h2>Game Content</h2>
            <p>
                Uranium Baseball is a free-to-play digital card game. Virtual cards, packs, in-game
                currency, and all other virtual items have no real-world monetary value and cannot be
                exchanged for real currency. We reserve the right to modify, rebalance, or remove
                any virtual items, cards, or game features at any time.
            </p>

            <h2>Conduct</h2>
            <p>
                You agree not to exploit bugs, use automated tools or bots, or engage in any activity
                that disrupts the service or gives an unfair advantage over other players. Violations
                may result in account suspension or termination.
            </p>

            <h2>Intellectual Property</h2>
            <p>
                All game content, artwork, and design are the property of Uranium Baseball. Player names
                and statistics are used under fair use for the purpose of historical baseball simulation.
            </p>

            <h2>Service Availability</h2>
            <p>
                We strive to keep Uranium Baseball available, but we do not guarantee uninterrupted
                access. We may perform maintenance, updates, or modifications to the service at any
                time. We reserve the right to discontinue the service with reasonable notice.
            </p>

            <h2>Disclaimer of Warranties</h2>
            <p>
                Uranium Baseball is provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo; without
                warranties of any kind, whether express or implied, including but not limited to implied
                warranties of merchantability, fitness for a particular purpose, or non-infringement.
            </p>

            <h2>Limitation of Liability</h2>
            <p>
                To the fullest extent permitted by law, Uranium Baseball and its operators shall not be
                liable for any indirect, incidental, special, consequential, or punitive damages, or any
                loss of data, profits, or goodwill, arising out of or in connection with your use of
                the service.
            </p>

            <h2>Indemnification</h2>
            <p>
                You agree to indemnify and hold harmless Uranium Baseball and its operators from any
                claims, damages, or expenses arising from your use of the service or violation of
                these terms.
            </p>

            <h2>Termination</h2>
            <p>
                We reserve the right to suspend or terminate accounts that violate these terms, at our
                sole discretion, with or without notice.
            </p>

            <h2>Governing Law</h2>
            <p>
                These terms are governed by and construed in accordance with the laws of the State of
                Washington, United States, without regard to its conflict of law provisions.
            </p>

            <h2>Changes</h2>
            <p>
                We may update these terms at any time. If we make significant changes, we will notify
                users through the site. Continued use of the service after changes constitutes
                acceptance of the updated terms.
            </p>

            <h2>Contact</h2>
            <p>
                Questions about these terms? Reach out via the <a href="/contact">contact page</a>.
            </p>
        </div>
    );
};

export default TermsPage;
